import { LagerauswertungAllProducts } from "@/components/lagerauswertung/lagerauswertung";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/lagerauswertung/all-products/$date")({
  component: RouteComponent,
});

function RouteComponent() {
  const { date } = Route.useParams();
  const navigate = useNavigate();
  const changeDate = (date: string) => {
    navigate({
      to: "/lagerauswertung/all-products/$date",
      params: { date },
    });
  };
  return <LagerauswertungAllProducts date={date} changeDate={changeDate} />;
}
